export default "__VITE_ASSET__BXrQfFM6__"